import { useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header id="top" className="border-b border-background-200 bg-background-50/92 backdrop-blur-md">
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:px-6">
        <h1 className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-eye-off-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-black tracking-wide text-foreground-950">黑料反差</span>
            <span className="mt-1 font-label text-[10px] tracking-[0.28em] text-foreground-500">
              HEILIAOFANCHA
            </span>
          </span>
        </h1>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <label className="hidden h-9 w-56 items-center gap-2 rounded-md border border-background-300 bg-background-50 pl-3 pr-2 text-sm text-foreground-500 lg:flex">
            <i className="ri-search-line" />
            <input
              type="text"
              placeholder="搜关键词 / 合集"
              className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
            <kbd className="rounded bg-background-200 px-1.5 py-0.5 font-label text-[10px] text-foreground-600">
              检索
            </kbd>
          </label>

          <a
            href="#collections"
            className="hidden h-9 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 text-sm text-background-50 transition-colors hover:bg-primary-700 md:inline-flex"
          >
            <i className="ri-add-line" />
            投稿线索
          </a>

          <button
            type="button"
            aria-label="打开导航"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#collections"
              onClick={() => setMenuOpen(false)}
              className="mt-1 inline-flex items-center gap-1.5 rounded-md bg-primary-600 px-3 py-2.5 text-sm text-background-50"
            >
              <i className="ri-add-line" />
              投稿线索
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}